import { createContext } from "react";
import { NamedProperty } from "sprint-common-web";

import { VersionType } from "../../../../common/data/lookup-data-providers/VersionTypesDataProvider";
import { EpisodeDetails, EpisodeVersionDetails, TvSeasonDetails, TvSeriesDetails } from "../../TvSeriesDetails";

interface ITvSeriesContext {
    tvSeries?: TvSeriesDetails;
    isLoading: boolean;
    moveToTvSeriesAssets(seasonId?: string, episodeId?: string, versionId?: string): void;
    setTvSeriesDetails(title: string, year?: number): void;
    updateSeason(seasonId: string, name: string, seasonNumber: number): void;
    addSeason(newSeason: TvSeasonDetails): void;
    updateEpisode(seasonId: string, episodeId: string, title: string, episodeNumber: number): void;
    addEpisode(seasonId: string, newSeason: EpisodeDetails): void;
    addEpisodeVersion(seasonId: string, episodeId: string, episodeVersion: EpisodeVersionDetails): void;
    updateEpisodeVersion(
        seasonId: string,
        episodeId: string,
        versionId: string,
        distirbutor: NamedProperty,
        code: string | undefined,
        type: VersionType
    ): void;
    setVersionAsMerged(seasonId: string, episodeId: string, versionId: string, mergedTargetId: string): void;
    silentTvSeriesRefresh(onRefresh?: (newTvSeries: TvSeriesDetails) => void): Promise<void>;
}

const defaultTvSeriesContext: ITvSeriesContext = {} as ITvSeriesContext;

export const TvSeriesContext = createContext<ITvSeriesContext>(defaultTvSeriesContext);
